module.exports = __webpack_public_path__ + "dantd-demo/static/media/chong.cc562d8c.png";